import {
  addTenantTerminologyBaseResource,
  updateTenantTerminologyBaseResource,
  getTenantTerminologyBaseResources,
  removeTenantTerminologyBaseResource,
} from '../../services/api-calls';

import resourceConfigurationHoc from '../common/resourceConfigurationHoc';
import { AWS_ROLE_ARN_REGEX } from '../../../../global/constants';
import { tenantAwsAccountsSubject$ } from '../../../../global/api-calls';
import { take } from 'rxjs/operators';

const TerminologyBase = resourceConfigurationHoc(
  'Terminology Base',
  {
    uuid: {
      header: 'ID',
      type: 'text',
      width: 500,
    },
    awsAccountId: {
      header: 'Aws Account Id',
      type: 'editableInput',
      validationHandler: async input => {
        return tenantAwsAccountsSubject$
          .pipe(take(1))
          .toPromise()
          .then(awsAccounts => {
            const awsAccountIds = new Set(
              awsAccounts.map((awsAccount, index) => {
                return awsAccount.awsAccountId;
              })
            );
            if (!awsAccountIds.has(input)) {
              throw Error(`must be one of registered accounts [${Array.from(awsAccountIds.values()).join(', ')}]`);
            }
          });
      },
    },
    tbTableName: {
      header: 'TB Table name',
      type: 'editableInput',
      validationHandler: async input => {
        if (!input) {
          throw Error('cannot be empty');
        }
      },
    },
    termIdentifier: {
      header: 'Term identifier',
      type: 'editableInput',
      validationHandler: async input => {
        if (!input) {
          throw Error('cannot be empty');
        }
      },
    },
    roleArn: {
      header: 'Role Arn',
      type: 'editableInput',
      validationHandler: async input => {
        if (!AWS_ROLE_ARN_REGEX.test(input)) {
          throw Error('must match valid AWS role ARN');
        }
      },
    },
  },
  addTenantTerminologyBaseResource,
  updateTenantTerminologyBaseResource,
  removeTenantTerminologyBaseResource,
  getTenantTerminologyBaseResources
);

export default TerminologyBase;
